export {
  default,
  algoliaSearchIndex,
  mediaHits,
  travelHits,
  marketplaceHits,
} from './AlgoliaSearch';
